import { GetStoryEventLogMeta, GetStoryEventLogPayload } from 'types/store/GetStoryEventLog';
import { createAsyncReducer } from 'utils/Redux';

import { getStoryEventLogActions } from '../actions';

export default createAsyncReducer<GetStoryEventLogMeta, GetStoryEventLogPayload>(getStoryEventLogActions);
